import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import MainLayout from "../../layouts/main/main_layout";
import AccessDenied from "../../components/access_denied/access_denied";
import useUser from "../../providers/user/user_provider";
import { RulesList } from "./components/view-rules";

export default function Rules() {
  const [searchParams, setUrlParam] = useSearchParams();
  const [page, setPage] = useState(
    searchParams?.has("page") ? parseInt(searchParams.get("page")!) : 1
  );
  const { hasPermission } = useUser();

  useEffect(() => {
    setUrlParam({ page: page.toString() });
  }, []);

  return (
    <MainLayout>
      {true || hasPermission("landing_pages", "read") ? (
        <RulesList />
      ) : (
        <Box display="flex" flex={1} width="100%" height="100%">
          <AccessDenied />
        </Box>
      )}
    </MainLayout>
  );
}

